/**
 * 69.5 the HQ's fall (decision 145: "the mode decides what the HQ's fall does"; its consequences OPEN as decision 165).
 * On the Foothold board, a side's HQ is its base's `ecotourism` body (`state.board.bases[].hq`). In a points battle (no
 * Operations push: there the defenders' base is the last sector, and its objectives are what count) its fall:
 * - stops the side's arrivals — at its base, and, the HQ being its web's only root, at its relays and FOBs (all cut);
 * - bleeds its tickets, HQ_FALL.bleed a second, until the battle ends (core/capturePoints.ts stepCapture), or with
 *   HQ_FALL.ends takes them all at once (the last side with tickets wins).
 * Pure.
 */
import type { GameState } from '../types';

/** Has `team`'s board HQ fallen (down, or gone)? False off the board, or for a base without an HQ. */
export function hqFallen(state: Pick<GameState, 'board' | 'structures'>, team: number): boolean {
  const base = state.board?.bases.find(b => b.team === team);
  if (!base || base.hq === undefined) return false;
  const hq = state.structures.find(s => s.id === base.hq);
  return !hq || hq.health <= 0;
}

/** Does the fall bite here: the board in a points battle, not under an Operations push? */
export function hqFallBites(state: Pick<GameState, 'board' | 'structures' | 'modeState'>, team: number): boolean {
  const ps = state.modeState.points;
  return !!ps && !(ps.front && ps.push) && hqFallen(state, team);
}
